export const AXP_CLIENT_APIGEE_URL = 'apigeeDomain';
export const AXP_CLIENT_HOME_API_URL = 'homeApiUrl';
export const AXP_CLIENT_TLSONLINE_WRAPPER_SERVICES_URL = 'tlsOnlineWrapperServicesUrl';
export const AXP_CLIENT_TULIPS_SMART_FILL_API_URL = 'tulipsSmartFillApiUrl';
export const AXP_CLIENT_BOOKING_LOCATION_API_BASE_URL = 'bookingLocationApiBaseUrl';
export const ONE_CMS_INTERNET_SSR_BASE_URL = 'oneCMSInternetSSRBaseUrl';
export const EWP_DOMAIN = 'ewpDomain';
